export const blockIconsBusinessandpaymentsTrendingFlatNew = (
	<span className='material-symbols-outlined'>trending_flat</span>
);
